module.exports = __webpack_public_path__ + "img/t5.9bb3318e.svg";